import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Menu,
  CardHeader,
  Card,
  CardContent,
  Box, CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  Modal,
  IconButton,
  Typography,
  Grid,
  TablePagination,
} from "@mui/material";
import ExcelJS from "exceljs";
import jsPDF from "jspdf"; // For PDF export
import "jspdf-autotable"; // For PDF table generation
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useParams,useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as Yup from "yup";
import { FieldArray } from 'formik';
import AddIcon from '@mui/icons-material/Add';



const baseUrl = process.env.REACT_APP_API_BASE_URL;

const PurchaseInvoiceList = () => {
  const [items, setItems] = useState([]); // Track the list of items from the backend
  const [openModal, setOpenModal] = useState(false); // Modal state
  const [isLoading, setIsLoading] = useState(true);
  const { userId, oId,role,pId } = useAuth();
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [deletingItemId, setDeletingItemId] = useState(null);

  //search fields
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [purchaseId, setPurchaseId] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editData, setEditData] = useState({}); // to hold the data for editing

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  const [selectedValue, setSelectedValue] = useState("today");
   
  const [totalPurchaseList, setTotalPurchaseList] = useState([]);
   const { purchaseCompanyName } = useParams(); // This will be URL-decoded automatically

   const location = useLocation();
  const soldItemData = location.state?.soldItemData;

  console.log("Company:", purchaseCompanyName); // Should log "ABCD Company"
  console.log("Sold Item:", soldItemData);
  
  const queryParams = new URLSearchParams(location.search);
  const dateRangeFromQuery = queryParams.get('dateRange');
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(dateRangeFromQuery || "currentMonth");


  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleDateRangeChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedValue(selectedValue);
  };

  // State to capture form input values
  const [newItem, setNewItem] = useState({
    items: "",
    // hsn: "",
    qty: "",
    priceItem: "",
    // discount: "",
    // category: "",
    description: "",
    // tax: "",
    measureUnits: "",
  });

  // Validation schema
//   const validationSchema = Yup.object().shape({
//     date: Yup.string().required("Date is required"),
//     items: Yup.string().required("Item Name is required"),
//     // hsn: Yup.string()
//     //   .matches(/^\d{4,8}$/, "HSN should be 4-8 digits")
//     //   .required("HSN is required"),
//     qty: Yup.number()
//       .min(1, "Quantity must be at least 1")
//       .required("Quantity is required"),
//     priceItem: Yup.number()
//       .positive("Price per item must be positive")
//       .required("Price per item is required"),
//     // discount: Yup.number()
//     //   .min(0, "Discount cannot be negative")
//     //   .max(100, "Discount cannot exceed 100%")
//     //   .required("Discount is required"),
//     // category: Yup.string().required("Category is required"),
//     description: Yup.string()
//       .max(200, "Description cannot exceed 200 characters")
//       .required("Description is required"),
//     // tax: Yup.string().required("Tax is required"),
//     measureUnits: Yup.string().required("Measure Units are required"),
//   });


//store user ids get api

  const fetchUsers = async () => {
      try {
          const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/STORE_DEPARTMENT/${oId}/${pId}`);
          if (!response.ok) {
              // throw new Error('Failed to fetch users');
              console.log("Failed to fetch users")
          }
          const data = await response.json();
          setUsers(data);
          if (data.length > 0) {
            setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
        }
      } catch (error) {
          console.error('Error fetching users:', error);
      }
  };


useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount






const handleDateChange = (event) => {
  const selectedValue = event.target.value;
  setSelectedDate(selectedValue);
  // ///dateFilter===selectedValue
  // if (selectedValue === "customDate") {
  //   setOpenCustomDialog(true); // Open custom date selection dialog
  // }
};


 //Total Purchase table get api
 const fetchTotalPurchaseList = async () => {
  if(!UserId) return;
  setIsLoading(true);
  try {

    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (selectedDate) {
      case "today":
        endpoint = `${baseUrl}/api/purchase/store/getAllTodayCompanyPurchaseDetails/${formattedDate}/${oId}/${UserId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/purchase/store/getAllYesterdayCompanyPurchaseDetails/${formattedDate}/${oId}/${UserId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/purchase/store/getAlllastWeekCompanyPurchaseDetails/${formattedDate}/${oId}/${UserId}`;
        break;
      case "currentMonth":
        endpoint = `${baseUrl}/api/purchase/store/getAllThisMonthCompanyPurchaseDetails/${formattedDate}/${oId}/${UserId}`;
        break;
      case "lastSixMonths":
        endpoint = `${baseUrl}/api/purchase/store/getAllLastSixMonthsCompanyPurchaseDetails/${formattedDate}/${oId}/${UserId}`;
        break;
      case "currentAcademicYear":
        endpoint = `${baseUrl}/api/purchase/store/getAllCurrentAcademicYearCompanyPurchaseDetails/${formattedDate}/${oId}/${UserId}`;
        break;
        default:
          endpoint =`${baseUrl}/api/purchase/store/getAllCurrentAcademicYearCompanyPurchaseDetails/${oId}/${UserId}`
          break;
    }

    const response = await fetch(endpoint);
    if (response.ok) {
            const itemsData = await response.json();
            // const sortedData=itemsData.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
            setItems(itemsData); // Set the fetched items to the state
    
            console.log("Items fetched successfully");
    
            // Extract unique categories
            const uniqueCategories = [
              ...new Set(itemsData.map((item) => item.category)),
            ];
            setCategoryOptions(uniqueCategories);
          } else {
            console.error("Failed to fetch items");
          }
} catch (error) {
  console.error('Error fetching users:', error);
}finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchTotalPurchaseList();
}, [dateRangeFromQuery,selectedDate,UserId ]);





  const handleCreateNewItem = () => {
    setOpenModal(true); // Open the modal
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  // Submit handler

// const handleSubmit = async (values, { setSubmitting, resetForm }) => {
//   try {
//     const apiUrl = `${baseUrl}/api/purchase/saveitems/${UserId}`;

//     // Create an array where each item includes all purchase fields
//     const payload = values.itemsList.map(item => ({
//       ...item,
//       purchaseDate: values.purchaseDate,
//       purchaseCompanyName: values.purchaseCompanyName,
//       purchaseCompanyAddress: values.purchaseCompanyAddress,
//       purchaseInvoice: values.purchaseInvoice,
//       companyNumber: values.companyNumber,
//       purchaseAmount: item.qty * item.priceItem, // you can also calculate this before submission
//     }));

//     const response = await fetch(apiUrl, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload), // <-- NOT wrapped in an object, it's a flat array
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || "Failed to create items");
//     }

//     toast.success("Items saved successfully!", { autoClose: 1000 });
//     fetchTotalPurchaseList();
//     handleCloseModal();
//     resetForm();
//   } catch (error) {
//     console.error("Error while creating items:", error.message);
//     toast.error(`Error: ${error.message}`);
//   } finally {
//     setSubmitting(false);
//   }
// };

const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  try {
    const apiUrl = `${baseUrl}/api/purchase/saveitems/${UserId}`;

    const payload = values.itemsList.map(item => ({
      ...item,
      purchaseDate: values.purchaseDate,
      purchaseCompanyName: values.purchaseCompanyName,
      purchaseCompanyAddress: values.purchaseCompanyAddress,
      purchaseInvoice: values.purchaseInvoice,
      companyNumber: values.companyNumber,
      purchaseAmount: item.qty * item.priceItem,
    }));

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let errorMessage = "Failed to create items";
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } else {
        const text = await response.text();
        errorMessage = text || errorMessage;
      }

      throw new Error(errorMessage);
    }

    toast.success("Items saved successfully!", { autoClose: 1000 });
    fetchTotalPurchaseList();
    handleCloseModal();
    resetForm();
  } catch (error) {
    console.error("Error while creating items:", error.message);
    toast.error(`Error: ${error.message}`, { autoClose: 3000 });
  } finally {
    setSubmitting(false);
  }
};



 

const filteredItems = items.filter(
  (item) =>
    item.purchaseCompanyName?.toLowerCase().includes(searchQuery.toLowerCase()) &&
    (selectedCategory ? item.category === selectedCategory : true)
);


  
  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  //Edit item  Details
  const handleEditSubmit = async () => {
    setIsSubmittingEdit(true);
    try {
      const queryParams = new URLSearchParams(editData).toString();
      const response = await fetch(
        `${baseUrl}/api/purchase/updateItems/${purchaseId}/${oId}?${queryParams}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editData),
        }
      );

      if (response.ok) {
        // Optionally: refresh data or update the edited item in your state
        toast.success("Item Details Updated successfully!", {
          autoClose: 1000,
        });
        fetchTotalPurchaseList();
        handleClose(); // Close the modal after update
      } else {
        console.error("Failed to update item");
        toast.error("Failed to Update Item Details.");
      }
    } catch (error) {
      console.error("Error updating item:", error);
      toast.error("Error Update Item Details.");
    } finally {
      setIsSubmittingEdit(false);
    }
  };

  // const handleDelete = async (item) => {
  //   const result = await Swal.fire({
  //     title: "Are you sure?",
  //     text: `You want to delete "${item.items}" Item From the Stock`,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#3085d6",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (result.isConfirmed) {
  //     setDeletingItemId(item.pId); // Start loading

  //     try {
  //       const response = await fetch(
  //         `${baseUrl}/api/purchase/deleteItems/${item.pId}/${oId}`,
  //         {
  //           method: "DELETE",
  //         }
  //       );

  //       if (response.ok) {
  //         toast.success("Item deleted successfully!", { autoClose: 1000 });
  //         fetchTotalPurchaseList();
  //       } else {
  //         toast.error("Failed to delete Item.");
  //       }
  //     } catch (error) {
  //       console.error("Error deleting item:", error);
  //       toast.error("Error deleting Item.");
  //     } finally {
  //       setDeletingItemId(null); // Stop loading
  //     }
  //   }
  // };




  const handleOpen = (item) => {
    setSelectedRow(item);
    setPurchaseId(item.pId);
    setEditData(item); // pre-fill the edit form
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    setEditData({});
  };

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

 const exportToExcel = () => {
  const filteredData = filteredItems.map((item, index) => ({
    index: index + 1,
    purchaseDate: item.purchaseDate
      ? new Date(item.purchaseDate).toLocaleDateString()
      : "N/A",
    companyName: item.purchaseCompanyName || "N/A",
    companyAddress: item.purchaseCompanyAddress || "N/A",
    invoice: item.purchaseInvoice || "N/A",
    companyNumber: item.companyNumber || "N/A",
    amount: item.purchaseAmount || "N/A",
  }));

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`PurchaseInvoice_List`);

  worksheet.columns = [
    { header: "S.No", key: "index", width: 8 },
    { header: "Purchase Date", key: "purchaseDate", width: 18 },
    { header: "Company Name", key: "companyName", width: 25 },
    { header: "Company Address", key: "companyAddress", width: 20 },
    { header: "Invoice", key: "invoice", width: 20 },
    { header: "Company Number", key: "companyNumber", width: 20 },
    { header: "Amount", key: "amount", width: 15 },
  ];

  filteredData.forEach((data) => {
    worksheet.addRow(data);
  });

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" },
    };
  });

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `PurchaseInvoice_List.xlsx`;
    link.click();
  });

  handleExportClose();
};

  const exportToPDF = () => {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Purchase Invoice List", 10, 8);

  const tableData = filteredItems.map((row, index) => [
    index + 1,
    row.purchaseDate ? new Date(row.purchaseDate).toLocaleDateString() : "N/A",
    row.purchaseCompanyName || "N/A",
    row.purchaseCompanyAddress || "N/A",
    row.purchaseInvoice || "N/A",
    row.companyNumber || "N/A",
    row.purchaseAmount || "N/A",
  ]);

  doc.autoTable({
    startY: 20,
    head: [
      [
        "S.No",
        "Purchase Date",
        "Company Name",
        "Company Address",
        "Invoice",
        "Company Number",
        "Amount",
      ],
    ],
    body: tableData,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
    },
    bodyStyles: {
      halign: "center",
    },
    theme: "grid",
  });

  doc.save(`PurchaseInvoice_List.pdf`);
  handleExportClose();
};

  const exportToJSON = () => {
  const processedData = filteredItems.map((item) => ({
    PurchaseDate: item.purchaseDate
      ? new Date(item.purchaseDate).toLocaleDateString()
      : "N/A",
    CompanyName: item.purchaseCompanyName || "N/A",
    CompanyAddress: item.purchaseCompanyAddress || "N/A",
    Invoice: item.purchaseInvoice || "N/A",
    CompanyNumber: item.companyNumber || "N/A",
    Amount: item.purchaseAmount || "N/A",
  }));

  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(processedData, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `PurchaseInvoice_List.json`;
  link.click();
  handleExportClose();
};



//create new items 
  const validationSchema = Yup.object().shape({
  purchaseDate: Yup.string().required("Required"),
  purchaseCompanyName: Yup.string().required("Required"),
  purchaseCompanyAddress: Yup.string().required("Required"),
  purchaseInvoice: Yup.string().required("Required"),
  companyNumber: Yup.string().required("Required"),
  itemsList: Yup.array().of(
    Yup.object().shape({
      items: Yup.string().required("Item Name is required"),
      qty: Yup.number().required("Quantity is required"),
      measureUnits: Yup.string().required("Measure Units are required"),
      description: Yup.string(),
      priceItem: Yup.number().required("Price per Item is required"),
    })
  ),
});

const initialValues = {
  purchaseDate: "",
  purchaseCompanyName: "",
  purchaseCompanyAddress: "",
  purchaseInvoice: "",
  companyNumber: "",
  itemsList: [
    { items: "", qty: "", measureUnits: "", description: "", priceItem: "" },
    { items: "", qty: "", measureUnits: "", description: "", priceItem: "" },
    { items: "", qty: "", measureUnits: "", description: "", priceItem: "" },
  ],
};





  return (
    <Card sx={{ marginTop: 10, marginRight: "15px", marginLeft: "15px" }}>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
            <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
                        <KeyboardBackspaceIcon fontSize="medium" />
                      </IconButton>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold", textAlign: "left" }}
            >
              {`${
              dateRangeFromQuery
                ? dateRangeFromQuery.charAt(0).toUpperCase() +
                  dateRangeFromQuery.slice(1)
                : ""
            } Purchase Items List`}
             
            </Typography>
            </Box>

            <Box display="flex" gap={2} alignItems="center">
              <Button
    onClick={handleCreateNewItem}
    sx={{
      backgroundColor: "#3f51b5",
      color: "#fff",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      "&:hover": { backgroundColor: "#303f9f" },
    }}
  >
    Create New Item
  </Button>
             
            </Box>
          </div>
        }
      />
      {/* <Grid item container alignItems="center" xs >
       
        <Typography variant="h3" sx={{paddingLeft:'10px',paddingTop:'5px',textAlign:'center'}}>
          Stock Items List
        </Typography>
      </Grid> */}
      <CardContent>
      <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
    mb: 2,
  }}
>
  {/* Left-side filters */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
 

     {/* Select Date */}
                 <Grid item >
                    <FormControl fullWidth variant="outlined" size="small" sx={{ minWidth: 180 }}>
                      <InputLabel id="date-select-label">Select DateRange</InputLabel>
                      <Select
                        value={selectedDate}
                        onChange={handleDateChange}
                        label="Select DateRange"
                      >
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="yesterday">Yesterday</MenuItem>
                        <MenuItem value="lastWeek">Last Week</MenuItem>
                        <MenuItem value="currentMonth">Current Month</MenuItem>
                        <MenuItem value="lastSixMonths">LastSix Months</MenuItem>
                        <MenuItem value="currentAcademicYear">Academic Year</MenuItem>
                        {/* <MenuItem value="customDate">Custom Date</MenuItem> */}
                      </Select>
                    </FormControl>
                  </Grid>

                  <TextField
      label="Search Company"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />

    {/* {isPrincipal && (
      <FormControl variant="outlined" size="small" sx={{ width: 170 }}>
        <InputLabel>Select Store Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Store Admin"
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )} */}
  </Box>

  {/* Right-side button */}
  {/* <Button
    onClick={handleCreateNewItem}
    sx={{
      backgroundColor: "#3f51b5",
      color: "#fff",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      "&:hover": { backgroundColor: "#303f9f" },
    }}
  >
    Create New Item
  </Button> */}
   <Button
                variant="contained"
                startIcon={<PresentToAllIcon />}
                onClick={handleExportClick}
                sx={{
                  backgroundColor: "#3f51b5", // Custom background color
                  color: "white", // Text color
                  fontWeight: "bold", // Bold text
                  "&:hover": { backgroundColor: "#303f9f" }, // Darker shade on hover
                }}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    backgroundColor: "#f5f5f5", // Light background color
                    "&:hover": { backgroundColor: "#e0e0e0" }, // Hover effect
                  }}
                >
                  <ListItemIcon>
                    <SimCardDownloadIcon sx={{ color: "#388e3c" }} />
                  </ListItemIcon>{" "}
                  {/* Green icon for Excel */}
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#388e3c" }} // Text color and bold
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <ListItemIcon>
                    <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />
                  </ListItemIcon>{" "}
                  {/* Red icon for PDF */}
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }} // Red text color
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToJSON}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <ListItemIcon>
                    <FilePresentIcon sx={{ color: "#f57c00" }} />
                  </ListItemIcon>{" "}
                  {/* Orange icon for JSON */}
                  <ListItemText
                    primary="JSON"
                    sx={{ fontWeight: "bold", color: "#f57c00" }} // Orange text color
                  />
                </MenuItem>
              </Menu>
</Box>


        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        <TableContainer
          component={Paper}
          style={{ maxHeight: "612px", overflowY: "auto" }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Purchase Date
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Company Name 
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                 Invoice 
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Company Number
                </TableCell>
                {/* <TableCell style={{ fontWeight: 'bold', fontSize: '14px', color: '#000', border: "1px solid #ACB4AE", textAlign: 'center', backgroundColor: "#A1F4BD", }}>ITEM ID</TableCell> */}
                {/* <TableCell
                 sx={{
                  borderRight: "1px solid #ddd",
                  padding: "2px",
                  textAlign: "center",
                  backgroundColor: "#fff9c4",
                  fontWeight:'bold',
                  fontSize:'14px'
                }}
                >
                  HSN
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Address
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Measure Units
                </TableCell> */}
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Category
                </TableCell> */}
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Description
                </TableCell> */}
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Price Per Item
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Total Amount
                </TableCell>
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Action
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Receipt
                </TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                   <TableCell colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                                                                              <Box display="flex" flexDirection="column" alignItems="center">
                                                                                <CircularProgress />
                                                                                <Typography variant="body2" sx={{ mt: 1 }}>
                                                                                  Loading Data...
                                                                                </Typography>
                                                                              </Box>
                                                                            </TableCell>
                </TableRow>
              ) : filteredItems.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    style={{ textAlign: "center", padding: "20px",fontSize:"15px" }}
                  >
                    No data available 
                  </TableCell>
                </TableRow>
              ) : (
                filteredItems.map((item, index) => (
                  <TableRow key={index}
                                      style={{
                                        backgroundColor: "white",
                                        transition: "background-color 0.3s",
                                        height: "40px", // Reduced row height
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "white"; // Default color
                                      }}
                                      >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.purchaseDate}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.purchaseCompanyName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.purchaseInvoice}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.companyNumber}
                    </TableCell>
                    {/* <TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center', fontSize: '15px' }}>{item.itId}</TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.hsn}
                    </TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.qty}
                    </TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.measureUnits || "n/a"}
                    </TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.category}
                    </TableCell> */}
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.description}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.purchaseCompanyAddress}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {item.purchaseAmount}
                    </TableCell>
                   
                    <TableCell
                                                      sx={{
                                                        borderRight: "1px solid #ddd",
                                                        padding: "4px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                     
                                                <Button
                                                type="button"
                                                onClick={() =>
                                                    navigate(
                                                    `/PurchaseReceipt`,
                                                    // `/PurchaseReceiptDummy`,
                                                    {
                                                        state: { soldItemData: item,purchaseInvoice: item.purchaseInvoice },
                                                    }
                                                    )
                                                }
                                                sx={{
                                                    backgroundColor: "#1976d2",
                                                    color: "white",
                                                    fontSize: "0.6rem",
                                                    height: "25px",
                                                    "&:hover": {
                                                    backgroundColor: "#1565c0",
                                                    },
                                                }}
                                                >
                                                View
                                                </Button>
                                                

                                                    </TableCell>

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <ToastContainer />
      </CardContent>

      {/* Modal for Create New Item */}
<Modal open={openModal} onClose={handleCloseModal} >
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      width: "70%",
      maxWidth: "1200px",
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 3,
    }}
  >
    <Typography variant="h6" sx={{ mt: -2, mb: 2,fontWeight: 'bold' }}>
  Create New Item
</Typography>


    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}  
    >
      {({ values, handleChange, handleBlur, errors, touched, isSubmitting }) => (
        <Form>
          <Grid container spacing={2}>
            {/* Company Info in One Row with small TextFields */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2.4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Select Date"
                    type="date"
                    name="purchaseDate"
                    value={values.purchaseDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.purchaseDate && touched.purchaseDate}
                    helperText={touched.purchaseDate && errors.purchaseDate}
                  />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Company Name"
                    name="purchaseCompanyName"
                    value={values.purchaseCompanyName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.purchaseCompanyName && touched.purchaseCompanyName}
                    helperText={touched.purchaseCompanyName && errors.purchaseCompanyName}
                  />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Company Address"
                    name="purchaseCompanyAddress"
                    value={values.purchaseCompanyAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.purchaseCompanyAddress && touched.purchaseCompanyAddress}
                    helperText={touched.purchaseCompanyAddress && errors.purchaseCompanyAddress}
                  />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Invoice Number"
                    name="purchaseInvoice"
                    value={values.purchaseInvoice}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.purchaseInvoice && touched.purchaseInvoice}
                    helperText={touched.purchaseInvoice && errors.purchaseInvoice}
                  />
                </Grid>
                <Grid item xs={12} sm={2.4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Company Number"
                    name="companyNumber"
                    value={values.companyNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.companyNumber && touched.companyNumber}
                    helperText={touched.companyNumber && errors.companyNumber}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Dynamic Items */}
            <FieldArray name="itemsList">
  {({ push, remove }) => (
    <>
      <Grid item xs={12}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Items
          </Typography>
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddIcon fontSize="small" />}
            onClick={() =>
              push({
                items: "",
                qty: "",
                measureUnits: "",
                description: "",
                priceItem: "",
              })
            }
          >
            Add Item
          </Button>
        </Box>
      </Grid>

      {/* Scrollable item rows container */}
      <Grid item xs={12}>
        <Box
        className="custom-sidebar-scrollbar"
          sx={{
            maxHeight: "250px", // adjust as needed
            overflowY: "auto",
            overflowX: "hidden",
            pr: 1,
          }}
        >
          {values.itemsList.map((item, index) => (
            <Grid
              container
              spacing={1}
              key={index}
              sx={{ mt: index === 0 ? 0 : 1.5 }}
            >
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Item Name"
                  name={`itemsList[${index}].items`}
                  value={item.items}
                  onChange={handleChange}
                  error={touched.itemsList?.[index]?.items && !!errors.itemsList?.[index]?.items}
                  helperText={touched.itemsList?.[index]?.items && errors.itemsList?.[index]?.items}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2.0}>
                <TextField
                  label="Quantity"
                  name={`itemsList[${index}].qty`}
                  type="number"
                  value={item.qty}
                  onChange={handleChange}
                  error={touched.itemsList?.[index]?.qty && !!errors.itemsList?.[index]?.qty}
                  helperText={touched.itemsList?.[index]?.qty && errors.itemsList?.[index]?.qty}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Measure Units"
                  name={`itemsList[${index}].measureUnits`}
                  value={item.measureUnits}
                  onChange={handleChange}
                  error={touched.itemsList?.[index]?.measureUnits && !!errors.itemsList?.[index]?.measureUnits}
                  helperText={touched.itemsList?.[index]?.measureUnits && errors.itemsList?.[index]?.measureUnits}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2.4}>
                <TextField
                  label="Description"
                  name={`itemsList[${index}].description`}
                  value={item.description}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2.1}>
                <TextField
                  label="Price per Item"
                  name={`itemsList[${index}].priceItem`}
                  type="number"
                  value={item.priceItem}
                  onChange={handleChange}
                  error={touched.itemsList?.[index]?.priceItem && !!errors.itemsList?.[index]?.priceItem}
                  helperText={touched.itemsList?.[index]?.priceItem && errors.itemsList?.[index]?.priceItem}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={0.3} >
                <IconButton onClick={() => remove(index)} color="error" size="small">
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Grid>
    </>
  )}
</FieldArray>


          </Grid>

          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button onClick={handleCloseModal} variant="outlined" sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "#3f51b5",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "#303f9f" },
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Loading..." : "Save Item"}
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  </Box>
</Modal>



      {/*// Modal FOR EDIT ITEM*/}
      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            padding: "20px",
            background: "white",
            margin: "auto",
            marginTop: "100px",
            width: "80%", // Adjusted to fit better in the viewport
            maxWidth: "800px", // Added max-width for larger screens
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            outline: "none",
          }}
        >
          <h2 style={{ color: "#333", textAlign: "center" }}>
            Edit Item Details{" "}
          </h2>

          {/* Flexbox Container for Fields */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <TextField
              label="Select Date"
              value={editData.purchaseDate || ""}
              onChange={(e) =>
                setEditData({ ...editData, purchaseDate: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            />
            <TextField
              label="Items"
              value={editData.items || ""}
              onChange={(e) =>
                setEditData({ ...editData, items: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            />
            {/* <TextField
              label="HSN"
              value={editData.hsn || ""}
              onChange={(e) =>
                setEditData({ ...editData, hsn: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            /> */}
            <TextField
              label="Quantity"
              value={editData.qty || ""}
              onChange={(e) =>
                setEditData({ ...editData, qty: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            />
            <TextField
              label="Price"
              value={editData.priceItem || ""}
              onChange={(e) =>
                setEditData({ ...editData, priceItem: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            />
            {/* <TextField
              label="Discount"
              value={editData.discount || ""}
              onChange={(e) =>
                setEditData({ ...editData, discount: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            /> */}
            {/* <TextField
              label="Category"
              value={editData.category || ""}
              onChange={(e) =>
                setEditData({ ...editData, category: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            /> */}
            <TextField
              label="Description"
              value={editData.description || ""}
              onChange={(e) =>
                setEditData({ ...editData, description: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            />
            {/* <TextField
              label="Tax"
              value={editData.tax || ""}
              onChange={(e) =>
                setEditData({ ...editData, tax: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            /> */}
            <TextField
              label="MeasureUnits"
              value={editData.measureUnits || ""}
              onChange={(e) =>
                setEditData({ ...editData, measureUnits: e.target.value })
              }
              variant="outlined"
              style={{ flex: "1 1 48%", margin: "5px" }} // Adjusting flex properties
            />
          </div>

          {/* Button Container */}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleClose}
              sx={{ mr: 2 }}
              color="primary"
              variant="outlined"
            >
              Cancel
            </Button>

            <Button
              onClick={handleEditSubmit}
              variant="contained"
              disabled={isSubmittingEdit}
              sx={{
                backgroundColor: "#3f51b5",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "#303f9f" },
              }}
            >
              {isSubmittingEdit ? "Updating..." : "Update"}
            </Button>
          </div>
        </div>
      </Modal>
    </Card>
  );
};

export default PurchaseInvoiceList;